// extracted by mini-css-extract-plugin
export default {"grid":"SeriesGridFullWidth_grid__cNtcy"};